export default __webpack_public_path__ + "static/media/simular_bg.8fc4f538.svg";